import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-950 text-secondary-200">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 group cursor-pointer">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-gamepad-line text-2xl text-primary-400"></i>
                </div>
                <span className="text-xl font-heading text-background-50 whitespace-nowrap">
                  黄油游戏库
                </span>
              </Link>
              <p className="text-sm text-secondary-300 leading-relaxed">
                精选独立游戏一站式畅玩平台，为独立游戏爱好者提供最优质的游戏发现和内容体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">游戏分类</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/category/action-adventure" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    动作冒险
                  </Link>
                </li>
                <li>
                  <Link to="/category/rpg" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    角色扮演
                  </Link>
                </li>
                <li>
                  <Link to="/category/strategy-simulation" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    策略模拟
                  </Link>
                </li>
                <li>
                  <Link to="/category/casual-puzzle" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    休闲益智
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/category/action-adventure" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    游戏库
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-sm"></i>
                  </div>
                  <span>support@huangyougame.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-discuss-line text-sm"></i>
                  </div>
                  <span>官方QQ群：123456789</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-secondary-400">
              &copy; {currentYear} 黄油游戏库 版权所有 | 沪ICP备2024000000号
            </p>
            <div className="flex items-center gap-5">
              <a href="#" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">隐私政策</a>
              <a href="#" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">服务条款</a>
              <a href="#" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">Cookie政策</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}